import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import { useDeactivateWorker } from '@/modules/workforce/Crew/apiHooks';
import { Button, Typography } from '@/shared/components/atoms';
import routes from '@/shared/constant/routes';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Trash from '~/images/shared/TrashWithoutColor.svg';

const DeactivateWorkerConfirmation: React.FC<{
  workerId: number;
  crewId: number;
  workerName: string;
}> = ({ workerId, crewId, workerName }) => {
  const { t } = useTranslation('common');
  const { closeModal } = useModal();
  const { push, pathname } = useRouter();

  const { mutate: deactivateWorkerMutation } = useDeactivateWorker();

  const handleDeactivate = () => {
    deactivateWorkerMutation(workerId, {
      onSuccess: () => {
        if (pathname === '/workforce/suppliers/[id]/worker/[workerId]')
          push(`${routes.suppliers}/${crewId}`);
        closeModal();
      },
    });
  };

  return (
    <div className='flex w-full flex-col items-center justify-center gap-32'>
      <div className='flex h-64 w-64 items-center justify-center rounded-full bg-error-90 text-center text-40 text-error-400'>
        <Trash />
      </div>
      <div className='flex w-full flex-col items-center text-center'>
        <Typography variant='h3'>
          {t('deactivate-worker-confirmation')}
        </Typography>
        <Typography variant='body2' className='w-5/6 text-surface-10'>
          {t('worker')}: {workerName}
        </Typography>
        <Typography variant='body2' className='w-5/6 text-surface-10'>
          {t('deactivate-worker-confirmation-details')}
        </Typography>
      </div>
      <div className='mt-20 flex w-full flex-grow justify-end gap-16'>
        <Button
          variant='text'
          type='button'
          size='sm'
          className='h-56 w-full !rounded-xl border-xs border-grey-200'
          onClick={handleDeactivate}
        >
          {t('deactivate')}
        </Button>
        <Button
          variant='filled'
          type='button'
          size='sm'
          className='h-56 w-full !rounded-xl border-xs border-grey-200'
          onClick={() => {
            closeModal();
          }}
        >
          {t('back')}
        </Button>
      </div>
    </div>
  );
};

export { DeactivateWorkerConfirmation };
